<template>
    <f7-page no-toolbar no-swipeback>
        <f7-navbar title="ĐĂNG KÝ" backLink="Trở lại"></f7-navbar>
        <p class="text-align-center">
            <img :src="require('@/assets/kos.logo.png')" alt="Logo" class="logo">
        </p>
        <f7-list form inset class="mb-2" autocomplete="off">
            <f7-list-input
                type="text"
                placeholder="Tài khoản"
                :value="form_register.username"
                @input="form_register.username = $event.target.value"
            >
                <f7-icon ios="f7:person" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Mật khẩu"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                info="Mật khẩu gồm 8 số"
                autocomplete="off"
                @blur="$event.target.type = 'password'"
                @focus="$event.target.type = 'text'"
                :value="form_register.password"
                @input="form_register.password = $event.target.value"
            >
                <f7-icon ios="f7:lock" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Nhập lại Mật khẩu"
                pattern="[0-9]{8}"
                inputmode="numeric"
                maxlength="8"
                autocomplete="off"
                @blur="$event.target.type = 'password'"
                @focus="$event.target.type = 'text'"
                :value="form_register.password_confirmation"
                @input="form_register.password_confirmation = $event.target.value"
            >
                <f7-icon ios="f7:lock" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Họ tên"
                :value="form_register.fullname"
                @input="form_register.fullname = $event.target.value"
            >
                <f7-icon ios="f7:doc_person" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Mã giới thiệu"
                :value="form_register.referal"
                @input="form_register.referal = $event.target.value"
            >
                <f7-icon ios="f7:qrcode" slot="media"></f7-icon>
            </f7-list-input>
        </f7-list>
        <f7-block-title>Chọn Server</f7-block-title>
        <f7-list inset>
          <f7-list-item
            radio
            radio-icon="start"
            title="Sài Gòn"
            name="server-selection"
            value="default" @change="form_register.server_region = 'default'" :checked="form_register.server_region === 'default'"
          ></f7-list-item>
          <f7-list-item
            radio
            radio-icon="start"
            title="Hà Nội"
            name="server-selection"
            value="hanoi" @change="form_register.server_region = 'hanoi'" :checked="form_register.server_region === 'hanoi'"
          ></f7-list-item>
        </f7-list>
        <f7-list form inset class="mb-2">
            <f7-list-input
                type="select"
                placeholder="Câu hỏi bảo mật 1"
                :value="form_register.secret_question_1"
                @input="form_register.secret_question_1 = $event.target.value"
            >
                <f7-icon ios="f7:question_square" slot="media"></f7-icon>
                <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Trả lời"
                :value="form_register.answer_secret_question_1"
                @input="form_register.answer_secret_question_1 = $event.target.value"
            >
                <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
            </f7-list-input>
            <f7-list-input
                type="select"
                placeholder="Câu hỏi bảo mật 1"
                :value="form_register.secret_question_2"
                @input="form_register.secret_question_2 = $event.target.value"
            >
                <f7-icon ios="f7:question_square" slot="media"></f7-icon>
                <option :value="item" v-for="(item, idx) in questions" :key="idx">{{ item }}</option>
            </f7-list-input>
            <f7-list-input
                type="text"
                placeholder="Trả lời"
                :value="form_register.answer_secret_question_2"
                @input="form_register.answer_secret_question_2 = $event.target.value"
            >
                <f7-icon ios="f7:quote_bubble" slot="media"></f7-icon>
            </f7-list-input>
        </f7-list>
        <f7-block inset class="mt-1">
            <f7-button fill color="primary" @click.prevent="submitRegister">ĐĂNG KÝ</f7-button>
        </f7-block>
    </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            questions: [
                'Biệt danh lúc nhỏ của bạn',
                'Tên đội thể thao yêu thích của bạn',
                '6 số cuối trong CMND/Passport',
                'Tên chú chó đầu tiên bạn nuôi',
                'Tên trường tiểu học mà bạn đã học',
                'Bạn thân của bạn thời thiếu niên',
                'Món ăn mà bạn thích nhất',
                'Bài hát yêu thích của bạn'
            ],
            form_register: {
                fullname: '',
                username: '',
                password: '',
                password_confirmation: '',
                referal: '',
                secret_question_1: 'Biệt danh lúc nhỏ của bạn',
                answer_secret_question_1: '',
                secret_question_2: 'Tên đội thể thao yêu thích của bạn',
                answer_secret_question_2: '',
                server_region: 'default'
            }
        };
    },
    computed: {
        ...mapState(['referal']),
    },
    methods: {
        submitRegister() {
            const app = this.$f7;

            app.dialog.preloader();

            this.$store.dispatch('register', this.form_register).then(() => {
                app.dialog.close();
                app.dialog.alert('Vui lòng đăng nhập để bất đầu sử dụng dịch vụ', 'ĐĂNG KÝ THÀNH CÔNG!', () => {
                    this.$f7.views.main.router.navigate('/dang-nhap');
                });
            }).catch((err) => {
                app.dialog.close();
                app.dialog.alert(err, 'LỖI!');
            });
        },
    },
    mounted(){
        this.form_register.referal = this.referal;
    }
};
</script>
<style scoped>
img.logo {
    height : 70px;
}
</style>
